import { render, staticRenderFns } from "./duoTrainingTileMobile.vue?vue&type=template&id=cf1b8d94&"
import script from "./duoTrainingTileMobile.vue?vue&type=script&lang=js&"
export * from "./duoTrainingTileMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports